module.exports = __webpack_public_path__ + "img/J0.1ad6b159.png";